import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";

class QuestionnaireName {
    public QuestionnaireId: string;
    public ShortName: string;
    public Names: KeyValuePair<string, string>[];

    constructor(fields?: Partial<QuestionnaireName>) {
        Object.assign(this, fields);
    }
}

export { QuestionnaireName };
